// Entry point for bundling
// Generated at: 2025-06-19T08:53:28.000Z
// This file imports all vendor dependencies and application code

// Import vendor dependencies first
import '../vendors.js';
import '../../__src/js/custom.js';
import '../../__src/js/basic/anchorTagBehavior.js';
import '../../__src/js/basic/backAsset.js';
import '../../__src/js/basic/backImg.js';
import '../../__src/js/basic/backToTop.js';
import '../../__src/js/basic/cookies.js';
import '../../__src/js/basic/fixBody.js';
import '../../__src/js/basic/isAnchorVisible.js';
import '../../__src/js/basic/log.js';
import '../../__src/js/basic/mobileMenu.js';
import '../../__src/js/basic/onload.js';
import '../../__src/js/basic/openModals.js';
import '../../__src/js/basic/serviceWorker.js';
import '../../__src/js/basic/sharingModule.js';
import '../../__src/js/basic/smoothScroll.js';
import '../../__src/js/basic/whenVisible.js';
import '../../__src/js/specific/customSlider.js';
import '../../__src/js/specific/parallax.js';
import '../../__src/js/toolbox/ScrollTo.js';
import '../../__src/js/toolbox/StickMe.js';
import '../../__src/js/toolbox/Stock.js';
import '../../__src/js/toolbox/Toolbox.js';
import '../../__src/js/toolbox/addGlobalEventListener.js';
import '../../__src/js/toolbox/addStuckWhenSticked.js';
import '../../__src/js/toolbox/faviconScheme.js';
import '../../__src/js/toolbox/slugify.js';
import '../../__src/js/toolbox/yogaMailingList.js';

// Application initialization code
document.addEventListener('DOMContentLoaded', () => {
  console.log('Application initialized via Vite');
});
